import {
  IContent,
  IPage
} from '../types'


const MAX_PAGES = 200


export function make(base: string, names: string[]): IContent {
  return {
    base,
    pages: [makePage(names)],
    index: 0
  }
}


export function setTaken(content: IContent, taken: Set<string>): IContent {
  currentPage(content).taken = taken
  console.log('setTaken to', Array.from(taken))
  return content
}


export function addPage(content: IContent, names: string[]): IContent {
  content.pages.push(makePage(names))

  // Make sure there are at most MAX_PAGES pages in the history
  // so that we don't slow things down over time.
  if (content.pages.length > MAX_PAGES) {
    content.pages.splice(0, Math.floor(MAX_PAGES/2))
  }

  content.index = content.pages.length - 1

  return content
}


export function hasPrevious(content: IContent) {
  return content.index > 0
}


export function currentPage(content: IContent): IPage {
  return content.pages[content.index]
}


export function numPagesBack(content: IContent): number {
  return content.index
}


export function numPagesForward(content: IContent): number {
  return content.pages.length - content.index - 1
}


function makePage(names: string[]): IPage {
  return {
    names,
    taken: new Set(),
    checked: false
  }
}


// WEBPACK FOOTER //
// ./src/service/content.ts